import { useBeforeunload } from 'react-beforeunload';

import { SafeAnyType } from 'src/utils/safeAny';
import { StateFormGetDirtyFields } from 'src/utils/stateForm';

export const useBeforeunloadOrganizationClean = (getDirtyFields: StateFormGetDirtyFields): void => {
  useBeforeunload((event: SafeAnyType) => {
    const isCancelButton = event.target?.activeElement?.classList?.contains('noUseBeforeunload');

    if (!isCancelButton && getDirtyFields().length) {
      event.preventDefault();
      event.returnValue = true;
    }
  });
};
